import React, { useState, useEffect, createContext } from "react";
import {
  getAllDrinkMenu,
  getAllHappyHourMenu,
  getAllBrunchMenu,
  getAllMerch,
  getAllEvents,
  getAllMenu,
  getMenuCategories,
  getToken,
} from "Api/apiService";
import { getAllReservation } from "Api/apiService";

export const AuthContext = createContext();
export const AppContext = createContext();

export const AppContextProvider = ({ children }) => {
  const [eventsData, setEventsData] = useState([]);
  const [menuItemData, setMenuItemData] = useState([]);
  const [drinkMenuItemData, setDrinkMenuItemData] = useState([]);
  const [happyHourMenuItemData, setHappyHourMenuItemData] = useState([]);
  const [brunchMenuItemData, setBrunchMenuItemData] = useState([]);
  const [merchItemData, setMerchItemData] = useState([]);
  const [reservationData, setReservationData] = useState([]);
  const [menuCategories, setMenuCategories] = useState([]);
  const [drinkMenuCategories, setDrinkMenuCategories] = useState([]);
  const [happyHourMenuCategories, setHappyHourMenuCategories] = useState([]);
  const [brunchMenuCategories, setBrunchMenuCategories] = useState([]);

  const value = {
    token: getToken(),
  };

  const fetchMenuItemData = async () => {
    try {
      const menuResponse = await getAllMenu();
      if (Array.isArray(menuResponse.data.menuItem)) {
        setMenuItemData(menuResponse.data.menuItem);
      } else {
        console.error(
          "Expected menuItem to be an array, but got:",
          typeof menuResponse.data.menuItem
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchDrinkMenuItemData = async () => {
    try {
      const drinkMenuResponse = await getAllDrinkMenu();
      if (Array.isArray(drinkMenuResponse.data.drinkMenuItem)) {
        setDrinkMenuItemData(drinkMenuResponse.data.drinkMenuItem);
      } else {
        console.error(
          "Expected drinkMenuItem to be an array, but got:",
          typeof drinkMenuResponse.data.drinkMenuItem
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchHappyHourMenuItemData = async () => {
    try {
      const happyHourMenuResponse = await getAllHappyHourMenu();
      if (Array.isArray(happyHourMenuResponse.data.happyHourMenuItem)) {
        setHappyHourMenuItemData(happyHourMenuResponse.data.happyHourMenuItem);
      } else {
        console.error(
          "Expected happyHourMenuItem to be an array, but got:",
          typeof happyHourMenuResponse.data.happyHourMenuItem
        );
      }
    } catch (error) {
      console.error(error);
    }
  };
  const fetchBrunchMenuItemData = async () => {
    try {
      const brunchMenuResponse = await getAllBrunchMenu();
      if (Array.isArray(brunchMenuResponse.data.brunchMenuItem)) {
        setBrunchMenuItemData(brunchMenuResponse.data.brunchMenuItem);
      } else {
        console.error(
          "Expected brunchMenuItem to be an array, but got:",
          typeof brunchMenuResponse.data.brunchMenuItem
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchMerchItemData = async () => {
    try {
      const merchResponse = await getAllMerch();
      if (Array.isArray(merchResponse.data.merchItem)) {
        setMerchItemData(merchResponse.data.merchItem);
      } else {
        console.error(
          "Expected merchItem to be an array, but got:",
          typeof merchResponse.data.merchItem
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchReservationData = async () => {
    try {
      const reservationResponse = await getAllReservation();
      if (Array.isArray(reservationResponse.data.reservationFull)) {
        setReservationData(reservationResponse.data.reservationFull);
      } else {
        console.error(
          "Expected reservation data to be an array, but got:",
          typeof reservationResponse.data
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchEventsData = async () => {
    try {
      const eventsResponse = await getAllEvents();
      if (Array.isArray(eventsResponse.data.event)) {
        setEventsData(eventsResponse.data.event);
      } else {
        console.error(
          "Expected event data to be an array, but got:",
          typeof eventsResponse.data.event
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchMenuCategories = async () => {
    try {
      const response = await getMenuCategories("menu");
      if (Array.isArray(response.data.categories)) {
        setMenuCategories(response.data.categories);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchDrinkMenuCategories = async () => {
    try {
      const response = await getMenuCategories("drink");
      if (Array.isArray(response.data.categories)) {
        setDrinkMenuCategories(response.data.categories);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchHappyHourMenuCategories = async () => {
    try {
      const response = await getMenuCategories("happyHour");
      if (Array.isArray(response.data.categories)) {
        setHappyHourMenuCategories(response.data.categories);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchBrunchMenuCategories = async () => {
    try {
      const response = await getMenuCategories("brunch");
      if (Array.isArray(response.data.categories)) {
        setBrunchMenuCategories(response.data.categories);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const eventsResponse = await getAllEvents();
        const menuResponse = await getAllMenu();
        const drinkMenuResponse = await getAllDrinkMenu();
        const happyHourMenuResponse = await getAllHappyHourMenu();
        const brunchMenuResponse = await getAllBrunchMenu();
        const merchResponse = await getAllMerch();
        const reservationResponse = await getAllReservation();
        const menuCategoriesResponse = await getMenuCategories("menu");
        const drinkCategoriesResponse = await getMenuCategories("drink");
        const happyHourCategoriesResponse = await getMenuCategories(
          "happyHour"
        );
        const brunchCategoriesResponse = await getMenuCategories("brunch");

        if (Array.isArray(reservationResponse.data.reservationFull)) {
          setReservationData(reservationResponse.data.reservationFull);
        } else {
          console.error(
            "Expected reservationFull to be an array, but got:",
            typeof reservationResponse.data.reservationFull
          );
        }

        if (Array.isArray(eventsResponse.data.event)) {
          setEventsData(eventsResponse.data.event);
        } else {
          console.error(
            "Expected event to be an array, but got:",
            typeof eventsResponse.data.event
          );
        }

        if (Array.isArray(menuResponse.data.menuItem)) {
          setMenuItemData(menuResponse.data.menuItem);
        } else {
          console.error(
            "Expected menuItem to be an array, but got:",
            typeof menuResponse.data.menuItem
          );
        }

        if (Array.isArray(drinkMenuResponse.data.drinkMenuItem)) {
          setDrinkMenuItemData(drinkMenuResponse.data.drinkMenuItem);
        } else {
          console.error(
            "Expected drinkMenuItem to be an array, but got:",
            typeof drinkMenuResponse.data.drinkMenuItem
          );
        }

        if (Array.isArray(happyHourMenuResponse.data.happyHourMenuItem)) {
          setHappyHourMenuItemData(
            happyHourMenuResponse.data.happyHourMenuItem
          );
        } else {
          console.error(
            "Expected happyHourMenuItem to be an array, but got:",
            typeof happyHourMenuResponse.data.happyHourMenuItem
          );
        }

        if (Array.isArray(menuCategoriesResponse.data.categories)) {
          setMenuCategories(menuCategoriesResponse.data.categories);
        }

        if (Array.isArray(drinkCategoriesResponse.data.categories)) {
          setDrinkMenuCategories(drinkCategoriesResponse.data.categories);
        }

        if (Array.isArray(happyHourCategoriesResponse.data.categories)) {
          setHappyHourMenuCategories(
            happyHourCategoriesResponse.data.categories
          );
        }

        if (Array.isArray(brunchCategoriesResponse.data.categories)) {
          setBrunchMenuCategories(brunchCategoriesResponse.data.categories);
        }

        if (Array.isArray(brunchMenuResponse.data.brunchMenuItem)) {
          setBrunchMenuItemData(brunchMenuResponse.data.brunchMenuItem);
        } else {
          console.error(
            "Expected brunchMenuItem to be an array, but got:",
            typeof brunchMenuResponse.data.brunchMenuItem
          );
        }

        if (Array.isArray(merchResponse.data.merchItem)) {
          setMerchItemData(merchResponse.data.merchItem);
        } else {
          console.error(
            "Expected merchItem to be an array, but got:",
            typeof merchResponse.data.merchItem
          );
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  return (
    <AuthContext.Provider value={value}>
      <AppContext.Provider
        value={{
          eventsData,
          menuItemData,
          drinkMenuItemData,
          happyHourMenuItemData,
          brunchMenuItemData,
          merchItemData,
          reservationData,
          setMenuItemData,
          setReservationData,
          fetchReservationData,
          fetchMenuItemData,
          fetchDrinkMenuItemData,
          fetchHappyHourMenuItemData,
          fetchBrunchMenuItemData,
          fetchMerchItemData,
          fetchEventsData,
          menuCategories,
          drinkMenuCategories,
          happyHourMenuCategories,
          brunchMenuCategories,
          fetchMenuCategories,
          fetchDrinkMenuCategories,
          fetchHappyHourMenuCategories,
          fetchBrunchMenuCategories,
        }}
      >
        {children}
      </AppContext.Provider>
    </AuthContext.Provider>
  );
};
